// Sprint 6-home-redesign: персональная шапка Главной.
// Имя = first_name (name-split). Пустое/грузится → «Здравствуйте!» без хвоста
// (не блокируем экран, если /auth/me ещё в полёте).

import { CalendarDays } from 'lucide-react';
import { useAuthMe } from '@/api/hooks/auth';
import { pluralize } from '@/lib/utils';

function formatRu(dateStr: string): string {
  const d = new Date(dateStr + 'T00:00:00Z');
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/** Текст приветствия: с именем (first_name) или нейтральное, если имени нет/грузится. */
export function greetingText(firstName: string | null | undefined): string {
  const name = (firstName ?? '').trim();
  return name ? `Здравствуйте, ${name}` : 'Здравствуйте!';
}

export function HomeGreeting({
  analysesCount,
  latestMeasuredAt,
}: {
  analysesCount: number;
  latestMeasuredAt: string | null;
}) {
  const { data } = useAuthMe();
  const firstName = (data?.user.first_name ?? '').trim();

  return (
    <section className="px-4 pt-2">
      <h1 className="text-hl-title font-extrabold leading-tight text-foreground">
        {greetingText(firstName)}
      </h1>
      <p className="mt-1 flex items-center gap-1.5 text-hl-secondary text-muted-foreground">
        <CalendarDays className="h-3.5 w-3.5 text-gray-400" aria-hidden="true" />
        <span>
          {analysesCount} {pluralize(analysesCount, ['анализ', 'анализа', 'анализов'])}
          {latestMeasuredAt && <> · последний {formatRu(latestMeasuredAt)}</>}
        </span>
      </p>
    </section>
  );
}
